(() => {
  const ENDPOINT = '/cart.js';
  let lastFetch = null;

  async function getCart() {
    if (!lastFetch) {
      lastFetch = fetch(ENDPOINT).then((response) => response.json());
    }
    return lastFetch;
  }

  function invalidateCartCache() {
    lastFetch = null;
  }

  function updateTitleVisibility(container, visibleCount) {
    const wrap = container.closest('.cart-product-recommendations, .product-recommendations');
    if (!wrap) return;

    const title = wrap.querySelector('[data-suggestions-title]');
    const recList = wrap.querySelector('[data-recommendations-list]');
    const recHasProducts = recList && recList.querySelector('.product-suggestion');

    if (title) {
      title.hidden = visibleCount === 0 && !recHasProducts;
    }
  }

  function hydrate(card) {
    const btn = card.querySelector('.myatc-btn');
    if (!btn || btn.dataset.bound === '1') return;

    btn.dataset.bound = '1';
    btn.addEventListener('click', async (event) => {
      event.preventDefault();
      btn.classList.add('btn--loading');

      const errorEl = card.querySelector('.error');

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            items: [{
              id: btn.dataset.variant,
              quantity: 1,
            }],
            sections: 'cart-ajax',
          }),
        });

        const data = await response.json();

        if (data.status === 422) {
          throw new Error(data.description || 'Could not add to cart.');
        }

        const addedProduct = data.items ? data.items[0] : data;
        const sectionsMarkup = data.sections && data.sections['cart-ajax'] ? data.sections['cart-ajax'] : null;

        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: {
            product: addedProduct,
            sectionsMarkup,
          },
        }));
      } catch (error) {
        if (errorEl) {
          errorEl.textContent = error.message;
          errorEl.style.display = 'block';
        }
      } finally {
        btn.classList.remove('btn--loading');
      }
    });
  }

  function refreshContainer(container, cart, optimisticItem) {
    const cards = Array.from(container.querySelectorAll('.bundle-upsell-card'));
    if (cards.length === 0) return 0;

    const context = container.dataset.context || 'cart';
    const maxCount = Number(container.dataset.maxCount) || 3;
    const productIds = new Set(cart.items.map((item) => Number(item.product_id)));

    if (optimisticItem) {
      const optimisticProductId = Number(
        optimisticItem.product_id || optimisticItem.id
      );
      if (optimisticProductId) {
        productIds.add(optimisticProductId);
      }
    }

    const sortedCards = cards.sort(
      (a, b) => Number(a.dataset.priority) - Number(b.dataset.priority)
    );

    let visible = 0;

    sortedCards.forEach((card) => {
      const triggerId = Number(card.dataset.triggerId);
      const bundleId = Number(card.dataset.bundleId);
      const eligible = context === 'pdp'
        ? !productIds.has(bundleId)
        : productIds.has(triggerId) && !productIds.has(bundleId);

      card.classList.add('is-hidden');

      if (eligible && visible < maxCount) {
        card.classList.remove('is-hidden');
        container.prepend(card);
        hydrate(card);
        visible += 1;
      }
    });

    updateTitleVisibility(container, visible);
    return visible;
  }

  async function refreshAll(options) {
    const optimisticItem = options && options.optimisticItem;

    if (optimisticItem) {
      invalidateCartCache();
      const cart = window.GIFT_DATA && window.GIFT_DATA.CART_JSON
        ? window.GIFT_DATA.CART_JSON
        : { items: [] };

      document.querySelectorAll('[data-bundle-upsells]').forEach((container) => {
        refreshContainer(container, cart, optimisticItem);
      });
    }

    invalidateCartCache();

    const cart = await getCart();
    document.querySelectorAll('[data-bundle-upsells]').forEach((container) => {
      refreshContainer(container, cart);
    });
  }

  window.BundleUpsells = {
    refresh: refreshAll,
  };

  document.addEventListener('ajaxProduct:added', function () {
    refreshAll();
  });
  document.addEventListener('cart:updated', refreshAll);
  document.addEventListener('DOMContentLoaded', refreshAll);
})();
